import { PhoneFrame } from "@/components/redesign/MarketingPhoneChatVisual";
import { WistiaVslEmbed } from "@/components/landing/WistiaVslEmbed";
import type { PhoneVideoBlockProps } from "@/puck/types";

export function PhoneVideoBlock({
  mediaId,
  autoplay = false,
  label,
}: Readonly<PhoneVideoBlockProps>) {
  return (
    <div className="flex h-full items-center justify-center">
      <div className="w-[68%] max-w-xs drop-shadow-[0_24px_48px_-24px_rgba(15,40,80,0.45)]">
        <PhoneFrame screenClassName="bg-black">
          <div className="relative min-h-0 flex-1">
            <WistiaVslEmbed
              mediaId={mediaId}
              autoplay={autoplay}
              title={label}
              orientation="portrait"
              bare
              className="h-full"
            />
          </div>
        </PhoneFrame>
      </div>
    </div>
  );
}
